import React, { useState } from 'react';
import AppointmentForm from "../../form/AppointmentForm";

const Profile = ({ name, profile }) => {
  const { qualification, designation, department, experience, expertise, image_url } = profile;

  const imageUrl = image_url
    ? `${process.env.REACT_APP_WEB_URL}${image_url}`
    : null;

  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <div className="doctor-profile-wrapper py-5 mt-lg-3" data-sal="fade" data-sal-duration="300">
        <div className="container">
          <div className="row px-lg-5" data-sal="slide-up" data-sal-duration="300">

            {imageUrl && (<div className="col-lg-4" data-sal="fade" data-sal-duration="300">
              <div className="doctor-profile-main-img-wrapper">
                <img
                  src={imageUrl}
                  className="img-fluid"
                  alt={`${name} Profile`}
                />
              </div>
            </div>)}

            <div className="col-lg-8" data-sal="slide-up" data-sal-duration="300">
              <div className="doctors-profile-right-content">
                <p className="doctor-profile-name" data-sal="fade" data-sal-duration="300">
                  {name}
                </p>
                {qualification && (
                  <p className="doctor-profile-designation" data-sal="fade" data-sal-duration="300">
                    {qualification}
                  </p>
                )}

                <div className="row" data-sal="slide-up" data-sal-duration="300">
                  {department && (
                    <div className="col-md-6 d-flex gap-1" data-sal="fade">
                      <p className="doctor-profile-desc-main">Department:</p>
                      <p className="doctor-profile-desc-sub">{department}</p>
                    </div>
                  )}

                  {experience && (
                    <div className="col-md-6 d-flex gap-1" data-sal="fade">
                      <p className="doctor-profile-desc-main">Experience:</p>
                      <p className="doctor-profile-desc-sub">{experience}</p>
                    </div>
                  )}

                  {designation && (
                    <div className="col-12 d-flex gap-1" data-sal="fade">
                      <p className="doctor-profile-desc-main">Designation:</p>
                      <p className="doctor-profile-desc-sub">{designation}</p>
                    </div>
                  )}

                  {expertise && (
                    <div className="col-12" data-sal="slide-up" data-sal-duration="500">
                      <p className="doctor-profile-expertise-main">Expertise in:</p>
                      <p className="doctor-profile-expertise-sub">
                        {expertise}
                      </p>
                    </div>
                  )}

                  <div className="col-12 mt-4 d-flex justify-content-center justify-content-md-start" data-sal="slide-down" data-sal-duration="500">
                    <button
                      type="button"
                      className="about-btn"
                      onClick={openModal}
                    >
                      Book an Appointment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AppointmentForm
        show={showModal}
        handleClose={closeModal}
        doctorName={name}
      />
    </>
  );
};

export default Profile;
